export default class Receita {
	constructor(
		pedido_id='',
		data='',
		valor='',
		forma_pagamento=''
	){
		this.pedido_id = pedido_id;
		this.valor = valor;
		this.forma_pagamento = forma_pagamento;

		// Settando a data atual
		if(data){
			this.data = data;
		} else {
			var d = new Date();

			// Dia atual
			var day = d.getDate();
			if(day < 10){
				day = "0"+day
			}

			// Mês atual
			var month = d.getMonth() + 1;
			if(month < 10){
				month = "0"+month
			}

			this.data = d.getFullYear()+'-'+month+'-'+day;
		}
	}
}